import { inject, Injectable, signal } from '@angular/core';
import { IEmployee } from '../interfaces/IEmployee';
import { LocalStorageService } from '../../../../core/services/LocalStorageService';
import { toObservable } from '@angular/core/rxjs-interop';
import { LastLoggedEmployee } from '../../../../core/types';

@Injectable({
  providedIn: 'root'
})
export class EmployeesStore {

  private readonly _localStorageService = inject(LocalStorageService);

  public readonly myEmployee = signal<IEmployee>(null);
  public readonly lastLoggedEmployees = signal<LastLoggedEmployee[]>(
    (this._localStorageService.getItem('last-logged-employees') || [])
      .filter((employee: LastLoggedEmployee) => !!employee?.initialLetters)
  );

  public constructor() {
    toObservable(
      this.lastLoggedEmployees
    ).subscribe(lastLoggedEmployees => {
      lastLoggedEmployees
        ? this._localStorageService.setItem('last-logged-employees', lastLoggedEmployees)
        : this._localStorageService.removeItem('last-logged-employees');
    });
  }
}
